import React from 'react';
import { string } from 'prop-types';
import { userConnectionPropTypes } from '../../../../sharedPropTypes';
import styles from './styles/styles.module.scss';
import UserActionCardBase from '../UserActionCardBase';
import { LanguageSupportUtil } from '../../../../../../utils/language_support_util';
import { fullName, cityRegion } from '../../../../utils/text_formatters';
import FollowButton from '../../../buttons/FollowButton';

const UserActionFollowCard = ({ languageRegionCode, userConnection }) => {
  return (
    <UserActionCardBase
      name={fullName(userConnection.user)}
      userLink={LanguageSupportUtil.wrapUrlSafe(`/${userConnection.user.slug}`, languageRegionCode)}
      profileImageUrl={userConnection.user?.profilePhoto?.href}
      subText={cityRegion(userConnection.user.location)}
      button={<FollowButton userConnection={userConnection} className={styles.followButton} />}
      className={styles.followContainer}
    />
  );
};

UserActionFollowCard.propTypes = {
  userConnection: userConnectionPropTypes.isRequired,
  languageRegionCode: string
};

UserActionFollowCard.defaultProps = {
  languageRegionCode: 'en-US'
};

export default UserActionFollowCard;
